import React from 'react';
import PropTypes from 'prop-types';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import AppleLogin from 'react-apple-login';
import GoogleLogin from 'react-google-login';

import AppleLoginButton from '../buttons/AppleLoginButton';
import FacebookLoginButton from '../buttons/FacebookLoginButton';
import GoogleLoginButton from '../buttons/GoogleLoginButton';

import baseStyles from '../../../styles/baseStyles.module.scss';
import styles from './styles/styles.module.scss';

// todo: this could be cooler if we looped over a config array instead, but its not critically important
const AltLoginsForm = ({ text, appleLoginHandler, facebookLoginHandler, googleLoginHandler, googleClientId, facebookAppId }) => {
  return (
    <div className={baseStyles.section}>
      <div className={styles.item}>
        <AppleLoginButton text={text.appleLogin} handler={appleLoginHandler} />
      </div>
      <FacebookLogin
        disableMobileRedirect
        appId={facebookAppId}
        autoLoad
        callback={facebookLoginHandler}
        scope="email,user_friends,user_gender,user_birthday,user_location"
        render={renderProps => (
          <div className={styles.item} onClick={renderProps.onClick}>
            <FacebookLoginButton text={text.facebookLogin} handler={facebookLoginHandler} />
          </div>
        )}
      />
      <GoogleLogin
        clientId={googleClientId}
        render={renderProps => (
          <div className={styles.item}>
            <GoogleLoginButton text={text.googleLogin} handler={renderProps.onClick} />
          </div>
        )}
        buttonText="Login"
        onSuccess={googleLoginHandler}
        onFailure={err => {
          console.error(err);
        }}
        cookiePolicy="single_host_origin"
      />
    </div>
  );
};

AltLoginsForm.propTypes = {
  appleLoginHandler: PropTypes.func.isRequired,
  facebookLoginHandler: PropTypes.func.isRequired,
  googleLoginHandler: PropTypes.func.isRequired,
  facebookAppId: PropTypes.number.isRequired,
  googleClientId: PropTypes.string.isRequired
};

export default AltLoginsForm;
